import { fetch } from '@atlassian/eoc-fetch';

import {
	type RoleBasedNotificationDetailResponse,
	type RoleBasedNotificationsResponse,
} from '../../common/types';

export const getRoleBasedNotificationsEndpoint = () =>
	fetch<RoleBasedNotificationsResponse>(`/v1/role-based-notifications`);

export const getRoleBasedNotificationDetailEndpoint = (settingId: string) =>
	fetch<RoleBasedNotificationDetailResponse>(`/v1/role-based-notifications/${settingId}`);
